export const getKeysByValue = (
  object: { [key: string]: string },
  value: string
): Array<string> | undefined =>
  Object.keys(object).filter(key => object[key] === value);
